// Which source a half of the assignment comes from: our own fleet, free text for
// a partner company, or — drivers only — nobody at all.
const AssignmentModeToggle = ({ label, value, options, onChange }) => (
    <div role="radiogroup" aria-label={label} className="tw:flex tw:flex-wrap tw:gap-2">
        {options.map((option) => {
            const isSelected = option.value === value;

            return (
                <button
                    key={option.value}
                    type="button"
                    role="radio"
                    aria-checked={isSelected}
                    onClick={() => onChange(option.value)}
                    className={`tw:!rounded-full tw:!px-4 tw:!py-2 tw:!font-hanken-grotesk tw:!text-[13px] tw:!leading-[16px] ${
                        isSelected
                            ? "tw:!border tw:!border-[#DBBE78] tw:!bg-[#DBBE78] tw:!text-white"
                            : "tw:!border tw:!border-[#E8E8E8] tw:!bg-white tw:!text-[#4E4E4E]"
                    }`}
                >
                    {option.label}
                </button>
            );
        })}
    </div>
);

export default AssignmentModeToggle;
